import React from 'react';
import { PlanInfoConfigurableStep } from '../../components';
import { getEligibility } from '../machine/utils';
import { BetterhelpOnboardingMachineContext } from '../types';

type BookingInterstitialPageProps = {
  context: BetterhelpOnboardingMachineContext;
  onNext: () => void;
  onBack: () => void;
};

export const BookingInterstitialPage: React.VFC<BookingInterstitialPageProps> = ({
  context,
  onNext,
  onBack,
}) => {
  const eligibility = getEligibility(context);
  const freeSessionsCount = context.inviteDetails?.sessionCount ?? 0;

  const res = React.useMemo(() => {
    if (eligibility.hasInsurance) {
      return (
        <PlanInfoConfigurableStep
          onNext={onNext}
          headerTitle="Your first"
          headerHighlight={`${freeSessionsCount} psychiatry sessions are free`}
          contentDescription={`Your first ${freeSessionsCount} sessions are fully paid for through your employee benefits with Betterhelp.`}
          nextButtonText="Schedule psychiatry"
          onBack={onBack}
        />
      );
    } else {
      return (
        <PlanInfoConfigurableStep
          onNext={onBack}
          nextButtonText="Add Insurance"

          secondaryButtonText="Continue without insurance"
          onSecondaryClick={onNext}

          headerTitle="Your first"
          headerHighlight={`${freeSessionsCount} psychiatry sessions are free`}
          contentTitle="To increase your number of free sessions add insurance."
          contentDescription={`Your first ${freeSessionsCount} sessions are fully paid for through your employee benefits with Betterhelp.`}
          onBack={onBack}
        />
      );
    }
  }, [ eligibility.hasInsurance, freeSessionsCount, onBack, onNext ]);


  if (!res) {
    console.log('No matching condition found for BookingInterstitialPage', eligibility);
    onNext();
  }

  return res;
};
